import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

let interview_Related = new Swiper('.s-interview__related-list', {
  centeredSlides: true,
  slidesPerView: 1.4,
  spaceBetween: 20,
  speed: 1000,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
    clickable: true,
  },
  breakpoints: {
    // スライドの表示枚数：768px以上の場合
    768: {
      centeredSlides: false,
      slidesPerView: 3,
      spaceBetween: 20,
    },
    // スライドの表示枚数：1300px以上の場合
    1300: {
      centeredSlides: false,
      slidesPerView: 3.3,
      spaceBetween: 60,
    },
  },
})
